import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  DeglawyFeatured, IDeglawyFeaturedStore,
} from '../../mobx-store/storeInterfaces/delawyFeaturedInterface';

interface IProps extends WithSnackbarProps {
  deglawyFeaturedStore: IDeglawyFeaturedStore;
  history: any;
}

@inject('deglawyFeaturedStore')
@observer
class DeglawyFeaturedScreen extends Component<IProps> {
  title: string = translate('deglawyFeaturesListPageTitle', {
  });

  addButton: any;

  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  tableData: any[] = [];

  constructor(props: IProps) {
    super(props);
    this.addButton = this.getAddDeglawyFeaturedButton();
    this.tableHeader = this.getDeglawyFeaturedTableHeader();
    this.tableCellTypes = this.getArticleTableCellTypes();
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    if (!value) {
      this.props.deglawyFeaturedStore.updateDelawyFeaturedStatus(value, index)
        .then(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
        })
        .catch((error: any) => {
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    } else if (this.getNumberOfActiveFeatured() < 3) {
      this.props.deglawyFeaturedStore.updateDelawyFeaturedStatus(value, index)
        .then(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
        })
        .catch((error: any) => {
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    } else {
      console.log('Error');
    }
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/deglawy/featured/${this.props.deglawyFeaturedStore.delawyFeaturesList[index].getId()}/edit`,
    );
  };

  handelAdd = (): void => {
    this.props.history.push('/deglawy/featured/new');
  };

  getAddDeglawyFeaturedButton = () => ({
    title: translate('deglawyFeaturedListAddButton', {
    }),
    onAdd: this.handelAdd,
  });

  getDeglawyFeaturedTableHeader = () => [
    {
      title: translate('deglawyFeaturedListTitleColumnTitle', {
      }),
    },
    {
      title: translate('deglawyFeaturedListPointsColumnTitle', {
      }),
    },
    {
      title: translate('deglawyFeaturedListStatusColumnTitle', {
      }),
    },
    {
      title: translate('deglawyFeaturedListEditColumnTitle', {
      }),
    },
  ];

  getDeglawyFeaturedTableData = () => this.props.deglawyFeaturedStore.delawyFeaturesList
    .map((deglawyFeatured: DeglawyFeatured) => ({
      ...deglawyFeatured.getFeatured(), edit: 'Edit',
    }));

  getNumberOfActiveFeatured = () => {
    let count = 0;
    for (const featured of this.props.deglawyFeaturedStore.delawyFeaturesList) {
      count += (featured.getIsActive() ? 1 : 0);
    }
    return count;
  };

  getArticleTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Text',
      key: 'points',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('deglawyFeaturedListStatusActive', {
      }),
      inactiveLabel: translate('deglawyFeaturedListStatusInactive', {
      }),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.tableData = this.getDeglawyFeaturedTableData();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('deglawyFeaturedListNoImageMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loading={this.props.deglawyFeaturedStore.loading}
        />
      </div>
    );
  }

  componentDidMount() {
    this.props.deglawyFeaturedStore.getDelawyFeatures();
  }
}

export default DeglawyFeaturedScreen;
